import { H3 } from '@h3/types';
import { request } from '@h3/request';
import * as Api from './constant';
/** 消息发送方 */
export const getBizDataBySceneGroupId = (data: H3.Plugin.scenegroupBizDataParams) => {
    return request<H3.Http.Response.H3Response<H3.Plugin.DingTalkBizData[]>>(Api.getBizDataBySceneGroupId, {
        method: H3.Http.MethodType.POST,
        data,
    });
};
